import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ChatService } from 'app/services/chat.service';
import { ShellTrackersService } from 'modules/shell/services/shell-trackers.service';
import { UnleashService } from 'shared/unleash/unleash.service';

import { UserService } from './../../../../app/services/user.service';

@Component({
	selector: 'header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
	@Input() isUserVisible = false;
	@Output() onChangeStatus = new EventEmitter();
	currentRoute = null;
	desktopMenu = [
		{
			label: 'Agenda',
			value: ['/calendar', '/'],
			command: () => {
				this.redirectTo('/calendar', 'calendar');
			},
		},
		{
			label: 'Disponibilidades',
			value: '/availabilities',
			command: () => {
				this.redirectTo('/availabilities', 'availabilities');
			},
		},
		{
			label: 'Clientes',
			value: '/contacts',
			command: () => {
				this.redirectTo('/contacts', 'contacts');
			},
		},
		{
			label: 'Financeiro',
			value: '/financials',
			command: () => {
				this.redirectTo('/financials', 'financials');
			},
		},
	];
	isSubMenuOpen = false;
	userData = {
		image: '',
		name: '',
		profileUrl: '',
	};
	userIsPremium = false;
	isUserActive = null;
	constructor(
		public userService: UserService,
		private router: Router,
		public chatService: ChatService,
		private shellTracker: ShellTrackersService,
		private unleash: UnleashService
	) {}

	ngOnInit(): void {
		this.updateUserData();
		this.router.events.subscribe((evt) => {
			if (evt instanceof NavigationEnd) {
				this.currentRoute = this.desktopMenu.find((menuItem) => {
					if (typeof menuItem.value === 'string') {
						return menuItem.value === evt.url;
					} else if (typeof menuItem.value === 'object') {
						return menuItem.value.includes(evt.url);
					}
				});
			}
		});
	}

	toggleSubMenu(value) {
		this.isSubMenuOpen = value;
	}

	async updateUserData() {
		const insightsv2Toggle = this.unleash.isEnabled('insightsv2');
		this.userService
			.checkSubscriptionAndContactTiers()
			.then(({ hasActiveSubscription }) => {
				this.userIsPremium = hasActiveSubscription;
				if (hasActiveSubscription && insightsv2Toggle) {
					this.desktopMenu = [
						...this.desktopMenu,
						{
							label: 'Desempenho',
							value: '/insights',
							command: () => {
								this.redirectTo('/insights', 'insights');
							},
						},
					];
				}
			});
		this.userService.getProfileData().then((user) => {
			this.isUserActive = user.active;
			this.userData.image = user.imageUrl;
			this.userData.name = user.displayName || '';
			this.userData.profileUrl = user.profileUrl || 'https://www.zenklub.com';
		});
	}

	redirectTo(url, trackScope) {
		this.shellTracker.trackHeaderMenuItemClick(trackScope);
		this.router.navigateByUrl(url);
	}

	changeStatus(e) {
		this.onChangeStatus.emit(e);
		setTimeout(() => {
			this.toggleSubMenu(false);
		}, 500);
	}

	async openChat() {
		this.shellTracker.trackHeaderMenuItemClick('chat');
		await this.chatService.setChatOpen(true, 'header', 'list');
	}

	openClariAndTrack() {
		this.shellTracker.trackHeaderMenuItemClick('clari');

		if (window.location.origin.includes('localhost')) {
			window.open(
				'https://clari.develop.zenklub.com/clari/pro',
				'_blank',
				'noopener'
			);
		}

		window.open(`${window.location.origin}/clari/pro`, '_blank', 'noopener');
	}
}
